import React from 'react';
import { heroData, siteConfig } from '../../data/mock';
import { MessageCircle, ArrowRight } from 'lucide-react';

const HeroSection = () => {
  const whatsappLink = `https://wa.me/${siteConfig.whatsappNumber}?text=${encodeURIComponent(siteConfig.whatsappMessage)}`;

  return (
    <section className="relative overflow-hidden">
      {/* Background Image */}
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('/hero-office.png')`
        }}
      />

      {/* Lighter dark overlay using requested color */}
      <div className="absolute inset-0 bg-[#24293f]/60" />

      {/* Lighter gradient from left using requested color */}
      <div className="absolute inset-0 bg-gradient-to-r from-[#24293f]/90 via-[#24293f]/60 to-transparent" />

      <div className="relative max-w-7xl mx-auto px-6 pt-32 pb-10 lg:pt-40 lg:pb-12">
        <div className="max-w-2xl">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 bg-[#24293f]/80 backdrop-blur border border-[#c9a962]/30 px-4 py-2 rounded-full mb-8">
            <div className="w-2 h-2 bg-[#c9a962] rounded-full animate-pulse" />
            <span className="text-neutral-300 text-sm">{heroData.badge}</span>
          </div>

          {/* Headline */}
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-8">
            {heroData.headline.split(' ').map((word, i) => (
              <span key={i} className={['empresa', 'caro', 'pelo', 'empréstimo?'].includes(word.toLowerCase()) ? 'text-[#c9a962]' : ''}>
                {word}{' '}
              </span>
            ))}
          </h1>

          {/* Subheadline */}
          <p className="text-xl text-neutral-200 leading-relaxed max-w-lg mb-10">
            {heroData.subheadline}
          </p>

          {/* CTA */}
          <a
            href={whatsappLink}
            target="_blank"
            rel="noopener noreferrer"
            className="group inline-flex items-center justify-center gap-3 bg-[#32D74B] hover:bg-[#28b03d] text-white px-5 py-3 text-sm md:px-8 md:py-4 md:text-lg rounded-lg font-bold uppercase tracking-wide transition-all duration-300 hover:scale-105 hover:shadow-xl hover:shadow-green-500/25"
          >
            {siteConfig.ctaText}
            <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
          </a>

          {/* Trust indicators */}
          <div className="flex items-center gap-6 mt-10">
            <div className="flex items-center gap-2">
              <div className="w-3 h-3 bg-[#32D74B] rounded-full" />
              <span className="text-neutral-300 text-sm">Redução da pressão no caixa</span>
            </div>
            <div className="flex items-center gap-2">
              <div className="w-3 h-3 bg-[#32D74B] rounded-full" />
              <span className="text-neutral-300 text-sm">Estratégia clara</span>
            </div>
          </div>
        </div>
      </div>

      {/* Subtle bottom gradient for smooth transition */}
      <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-[#24293f] to-transparent pointer-events-none" />
    </section>
  );
};

export default HeroSection;
